import {Link} from 'gatsby';
import * as React from 'react';
import {Helmet} from 'react-helmet';

import favicon from '_images/favicon.png';
// import iconFacebook from '_images/icon-facebook-orange.svg';
// import iconInstagram from '_images/icon-instagram-orange.svg';
// import iconYoutube from '_images/icon-youtube-orange.svg';
// import logo from '_images/logo-sm.png';
import Footer from '_sections/footer';
import Header from '_sections/header';

const Layout = ({children}: {children: React.ReactNode}) => {
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" type="image/png" href={favicon} />
      </Helmet>
      <main className="bg-white" id="main-wrapper">
        <Header />
        {children}
        <Footer />
      </main>
    </>
  );
};

export default Layout;
